import React from 'react'
import styled from 'styled-components'
import {LoadingLayer} from "../LoadingLayer";

type Block2Types = {
    className?: string,
    title?: any
    loading?: any
    content?: { mainText?: any, subText?: any }
}

function Block2(props: Block2Types) {

    return (
        <StyledBlock2 className={props.className}>
            {props.loading && <LoadingLayer/>}
            <div className='styled_title'>{props.title}</div>
            <div className='styled_content'>
                <b>{props?.content?.mainText}</b>
                {props?.content?.subText}
            </div>
        </StyledBlock2>
    )
}


Block2.defaultProps = {
    key: 'Key',
    content: { mainText: 'mainText', subText: 'subText' }


}

const StyledBlock2 = styled.div`
  background: white;
  font-family: "Open Sans";
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 15px;
  padding: 20px 20px;
  box-sizing: border-box;
  position: relative;

  .styled_title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .styled_content {
    font-weight: normal;
    font-size: 18px;
    display: flex;
    margin-top: 14px;
    flex-direction: column;
    text-align: center;

    b {
      font-size: 28px;
    }
  }



`

export default Block2